export default "__VITE_ASSET__6prljvd$__"